<ng-container *ngIf="data">
	<amp-story
		standalone
		[attr.title]="data.title"
		publisher="Clearcals"
		publisher-logo-src="https://img.clearcals.com/site/images/instant_plan_how_it_works/hint_app.webp"
		[attr.poster-portrait-src]="data.image"
	>
		<ng-container *ngFor="let item of data.ampPages; let i = index">
			<ng-container *ngIf="item.image">
				<amp-story-page [attr.auto-advance-after]="item?.pageDuration + 's'" id="page-{{ i }}">
					<amp-story-grid-layer template="fill">
						<amp-img
							layout="fill"
							src="{{ item.image }}"
							alt="{{ item['alt-text'] }}"
							srcset="{{ item.image }} 3024w, {{ item.image }} 2419w"
							sizes="(min-width: 1024px) 60vh, 134vw"
							disable-inline-width="true"
							class="i-amphtml-element i-amphtml-layout-fill i-amphtml-layout-size-defined i-amphtml-built i-amphtml-layout"
							i-amphtml-layout="fill"
							><img
								decoding="async"
								alt="{{ item.text }}"
								sizes="(min-width: 1024px) 60vh, 134vw"
								srcset="{{item.image}} 3024w, {{item.image}} 2419w"
								src="{{ item.image }}"
								class="i-amphtml-fill-content i-amphtml-replaced-content"
						/></amp-img>
					</amp-story-grid-layer>
					<ng-container *ngTemplateOutlet="storyTemplate; context: { item: item }"></ng-container>
				</amp-story-page>
			</ng-container>

			<ng-container *ngIf="item.video">
				<amp-story-page auto-advance-after="video1" id="page-{{ i }}">
					<amp-story-grid-layer template="fill">
						<amp-video
							id="video1"
							autoplay
							width="720"
							height="1280"
							layout="fill"
							poster="{{ item.videoPoster }}"
							alt="{{ item['alt-text'] }}"
							playsinline
						>
							<source src="{{ item.video }}" type="video/mp4" />
							<div fallback>
								<!-- TODO: add loader -->
								<p>Your browser doesn't support HTML5 video.</p>
							</div>
						</amp-video>
					</amp-story-grid-layer>
					<ng-container *ngTemplateOutlet="storyTemplate; context: { item: item }"></ng-container>
				</amp-story-page>
                        </ng-container>
                </ng-container>

                <amp-story-page id="more-stories">
                        <amp-story-grid-layer template="fill">
                                <div class="next-story-container">
                                        <a
                                                class="next-story-link"
                                                [href]="nextStoryUrl"
                                                [attr.target]="'_top'"
                                                [attr.aria-label]="'View next story: ' + nextStoryTitle"
                                        >
                                                View next Story
                                        </a>
                                </div>
                        </amp-story-grid-layer>
                </amp-story-page>

        </amp-story>
</ng-container>

<ng-template #storyTemplate let-item="item">
	<amp-story-grid-layer template="vertical">
		<div
			*ngIf="item?.title || item?.description"
			[ngClass]="item?.theme + ' ' + item?.textPosition"
		>
			<h1 [attr.animate-in]="animationOptionsMap[item?.textAnimation]" animate-in-duration="1.4s" *ngIf="item?.title">
				{{ item?.title }}
			</h1>
			<p [attr.animate-in]="animationOptionsMap[item?.textAnimation]" animate-in-duration="1.4s" *ngIf="item?.description">
				{{ item?.description }}
			</p>
		</div>
	</amp-story-grid-layer>
</ng-template>
